import dynamic from 'next/dynamic';
import { ContactPhoneSlideProps } from './ContactPhoneSlide';

export const DynamicContactPhoneSlide = dynamic<ContactPhoneSlideProps>(() =>
    import('./ContactPhoneSlide').then(md => md.ContactPhoneSlide),
);
